import { Box, Chip, Typography } from '@material-ui/core'
import { components, constants, useTranslation, useServices, useWhiteLabelServiceSettings } from 'cng-web-lib'

import AceHwyInbondArrivalApiUrls from 'src/apiUrls/AceHwyInbondArrivalApiUrls'
import React, { useEffect, useState, useRef } from 'react'
import AceHwyInbondArrivalKeys from 'src/constants/locale/key/AceHwyInbondArrival'
import AceHighwayAbiInbondEventKeys from 'src/constants/locale/key/AceHighwayAbiInbondEvent'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment-timezone'
import Table from '../../components/aciacehighway/Table'
import ConfirmDialog from '../common/ConfirmDialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import pathMap from 'src/paths/pathMap'
import { getStatusMetadata } from '../../common/NACommon'
import { FileForUserGetPartyId, FileForUserGetUserDetails, GetLoggedInUserPartyName } from 'src/common/FileForUserCommon'
import InbondEventFormProperties from '../acehighway/abiInbondEvent/FormProperties'
import InbondArrivalFormProperties from './FormProperties'
import InbondEventUploadDialog from '../acehighway/abiInbondEvent/InbondEventUploadDialog'
import { fetchUser } from "src/views/userprofile/UserProfileService.js";
import ChargeTypeDialog from 'src/views/common/ChargeTypeDialog'
import CngBackdrop from "src/components/cngcomponents/CngBackDrop";
import ACEHwyInbondArrivalTranslationText from 'src/views/aceHwyInbondArrival/context/ACEHwyInbondArrivalTranslationText'
import ACEHighwayInbondEventTranslationText from 'src/views/acehighway/contexts/ACEHighwayInbondEventTranslationText'
const {
  table: { useFetchCodeMaintenanceLookup },
  CngGridItem
} = components

const {
  locale: {
    key: { UiComponentKeys }
  },
  filter: { BETWEEN, EQUAL, IN, LIKE }
} = constants

function TablePage(props) {
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const { history, location, showNotification } = props
  const { securedSendRequest } = useServices();

  const tableRef = useRef(null)
  const [lookups, setLookups] = useState(null)
  const [uploadInbondEventDialog, setUploadInbondEventDialog] = useState({ open: false, tableRef: null })
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    inbondArrival: null
  })
  const [upsUser, setUpsUser] = useState(false);

  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.ACE_HIGHWAY_INBOND_ARRIVAL
  ])
  const aceHwyInbondArrivalTranslationText = ACEHwyInbondArrivalTranslationText()
  const aceHighwayInbondEventTranslationText = ACEHighwayInbondEventTranslationText();
  const { createRecord, deleteRecord } = useServices()
  const whiteLabelServiceSettings = useWhiteLabelServiceSettings("custom-layout");

  const [chargeTypes, setChargeTypes] = useState([])
  const [submitDialog, setSubmitDialog] = useState({ open: false, items: [] })  

  const [isSuperParty, setSuperParty] = useState(false);
  const [loading, setLoading] = useState(false)
  
  const [user, setUser] = useState([]);
  useEffect(() => {
    let fileForUserDetails = FileForUserGetUserDetails();
    fetchUser(setUser, securedSendRequest, fileForUserDetails);
  }, []);

  useEffect(() => {
    if (whiteLabelServiceSettings && whiteLabelServiceSettings.length > 0) {
      const topBarId = whiteLabelServiceSettings[0].custom.customTopBarId;
      setUpsUser(topBarId && topBarId.trim() === "UpsCustomTopBar");
    }
  }, [])

  useEffect(() => {
    Promise.all([
      // Message code
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACE_HWY_INBOND_TYPE' }],
        undefined,
        'code'
      ),
      // Status
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACE_HW_STATUS' }],
        undefined,
        'code'
      ),
      // Message Function
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'MESSAGE_FUNCTION_INBOND' }],
        undefined,
        'code'
      ),
      // Message Function
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACE_HW_ABI_ACTION' }],
        undefined,
        'code'
      ),
      // Charge type
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'BILLING_CHARGE_TYPE' }],
        undefined,
        'code'
      ),
      // Super party
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'BILLING_SUPER_PARTY' }],
        undefined, 'code'
      )
    ]).then(([messageCode, status, inbondMsgFunc, abiMsgFunc, billingChargeTypes, billingSuperParty]) => {
      compileChargeTypes(billingChargeTypes)

      Object.keys(billingSuperParty).forEach(e => {
        if (e == GetLoggedInUserPartyName()) {
          console.log("logged party:"+e,GetLoggedInUserPartyName);
          setSuperParty(true);
        }
      })
      // let msgFunc = { ...inbondMsgFunc, ...abiMsgFunc }
      setLookups({ messageCode, status, inbondMsgFunc, abiMsgFunc })
    })
  }, [])

  function compileChargeTypes(billingChargeTypes) {
    var jsonArray = [];
    if (billingChargeTypes) {
      Object.entries(billingChargeTypes).forEach((e) => {
        var jsonObject = { code: e[0], desc: e[1] }
        jsonArray.push(jsonObject)
      })
    }
    setChargeTypes(jsonArray)
  }

/*  function makeTranslatedTextsObject() {
    let aceHwyInbondArrival = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: aceHwyInbondArrival
      }
    )
    let tripNo = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.TRIP_NO
    )
    let etaFirstPortUS = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.ETA_FIRST_PORT_US
    )
    let firstPort = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.FIRST_PORT
    )
    let inbondNumber = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.INBOND_NUMBER
    )
    let inbondDate = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.INBOND_DATE
    )
    let inbondDestination = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.INBOND_DESTINATION
    )
    let arrivalPort = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.ARRIVAL_PORT
    )
    let firmsCode = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.FIRMS_CODE
    )
    let msgFunction = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.MSG_FUNCTION
    )
    let actionCode = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.ACTION_CODE
    )
    let status = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.STATUS
    )
    let editButton = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.EDIT_BUTTON
    )
    let cloneButton = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.CLONE_BUTTON
    )
    let deleteButton = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.DELETE_BUTTON
    )
    let id = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.ID
    )
    let createdBy = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.CREATED_BY
    )
    let createdDate = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.CREATED_DATE
    )
    let updatedBy = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.UPDATED_BY
    )
    let updatedDate = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.UPDATED_DATE
    )
    let submittedBy = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.SUBMITTED_BY
    )
    let submittedDate = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.SUBMITTED_DATE
    )
    let version = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.VERSION
    )
    let partyId = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.PARTY_ID
    )
    let cloneMultipleRecords = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.CLONE_MULTIPLE_RECORDS
    )
    let messageCode = translate(
      Namespace.ACE_HIGHWAY_INBOND_ARRIVAL,
      AceHwyInbondArrivalKeys.MESSAGE_CODE
    )

    let masterBol = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.MASTER_BOL
    )

    let submitButton = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.SUBMIT_BUTTON
    )

    let submitInvalidMsg = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.SUBMIT_INVALID_MSG
    )

    let submitSuccessMsg = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.SUBMIT_SUCCESS_MSG
    )

    let submitFailMsg = translate(
      Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT,
      AceHighwayAbiInbondEventKeys.SUBMIT_FAIL_MSG
    )

    return {
      aceHwyInbondArrival,
      tableTitle,
      id,
      createdBy,
      createdDate,
      updatedBy,
      updatedDate,
      submittedBy,
      submittedDate,
      version,
      partyId,
      messageCode,
      tripNo,
      etaFirstPortUS,
      firstPort,
      inbondNumber,
      inbondDate,
      inbondDestination,
      arrivalPort,
      firmsCode,
      msgFunction,
      actionCode,
      status,
      editButton,
      cloneButton,
      deleteButton,
      cloneMultipleRecords,
      masterBol,
      submitButton,
      submitInvalidMsg,
      submitSuccessMsg,
      submitFailMsg
    }
  }*/

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  const columns = [
    {
      field: 'inbond7512No',
      sortKey: 'inbond7512No',
      title: aceHighwayInbondEventTranslationText.inbondNumber
    },
    {
      field: 'tripNo',
      sortKey: 'tripNo',
      title: aceHwyInbondArrivalTranslationText.tripNo,
      render: (data) => (
        <Box>
          <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
            {data.tripNo}
          </Typography>
          <Typography color='textSecondary' style={{ fontSize: 12, lineHeight: 1.2 }}>
            {getLookupValue('messageCode', data.messageCode)}
          </Typography>
        </Box>
      )
    },
    {
      field: "masterBol",
      sortKey: 'masterBol',
      title: aceHighwayInbondEventTranslationText.masterBol,
      render: (data) => {
        if (data.masterBolIssuerCode && data.masterBol) {
          return (
            <Typography variant='inherit'>
              {data.masterBolIssuerCode + data.masterBol}
            </Typography>
          )
        }
      }
    },
    {
      field: 'inbondDestination',
      sortKey: 'inbondDestination',
      title: aceHwyInbondArrivalTranslationText.inbondDestination+"/"+aceHighwayInbondEventTranslationText.arrivalPort
    },
    {
      field: 'inbondDate',
      sortKey: 'inbondDate',
      title: aceHwyInbondArrivalTranslationText.inbondDate,
      render: (data) =>
        data.inbondDate &&
        moment(data.inbondDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'firstPort',
      sortKey: 'firstPort',
      title: aceHwyInbondArrivalTranslationText.firstPort
    },
    {
      field: 'etaFirstPortUS',
      sortKey: 'etaFirstPortUS',
      title: aceHwyInbondArrivalTranslationText.etaFirstPortUS,
      render: (data) =>
        data.etaFirstPortUS &&
        moment(data.etaFirstPortUS).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'msgFunction',
      sortKey: 'msgFunction',
      title: aceHighwayInbondEventTranslationText.actionCode,
      render: (data) => (
        <Box>
          <Typography component='div' variant='inherit'>
            {data.messageCode ? getLookupValue('inbondMsgFunc', data.msgFunction) : getLookupValue('abiMsgFunc', data.msgFunction)}
          </Typography>
        </Box>
      )
    },
    {
      field: 'submittedDate',
      sortKey: 'submittedDate',
      title: aceHwyInbondArrivalTranslationText.submittedDate,
      render: (data) =>
        data.submittedDate && moment(data.submittedDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'status',
      sortKey: 'status',
      title: aceHighwayInbondEventTranslationText.status,
      render: (data) => {
        const status = getStatusMetadata(data.status)

        return (
          <Chip
            label={status.label}
            size='small'
            style={{
              backgroundColor: status.color,
              color: status.contrastColor
            }}
          />
        )
      }
    }
  ]

  const filters = [
    {
      label: aceHighwayInbondEventTranslationText.inbondNumber,
      type: 'textfield',
      name: 'inbond7512No',
      operatorType: LIKE
    },
    {
      label: aceHwyInbondArrivalTranslationText.tripNo,
      type: 'textfield',
      name: 'tripNo',
      operatorType: LIKE
    },
    {
      label: aceHighwayInbondEventTranslationText.masterBol,
      type: 'textfield',
      name: 'masterBol',
      operatorType: LIKE
    },
    {
      label: aceHwyInbondArrivalTranslationText.inbondDestination,
      type: 'textfield',
      name: 'inbondDestination',
      operatorType: LIKE
    },
    {
      label: aceHwyInbondArrivalTranslationText.inbondDate,
      type: 'daterange',
      name: 'inbondDate',
      operatorType: BETWEEN
    },
    {
      label: aceHwyInbondArrivalTranslationText.firstPort,
      type: 'textfield',
      name: 'firstPort',
      operatorType: LIKE
    },
    {
      label: aceHwyInbondArrivalTranslationText.etaFirstPortUS,
      type: 'daterange',
      name: 'etaFirstPortUS',
      operatorType: BETWEEN
    },
    {
      label: aceHighwayInbondEventTranslationText.actionCode,
      type: 'checkbox',
      name: 'msgFunction',
      operatorType: IN,
      options: [
        {
          label: aceHighwayInbondEventTranslationText.actionCodeOriginal,
          value: '64',
          filterValue: {
            value: '64'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeChange,
          value: '4',
          filterValue: {
            value: '4'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeCancel,
          value: '1',
          filterValue: {
            value: '1'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeArriveEntireInBond,
          value: '1',
          filterValue: {
            value: '1'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeArriveBillOfLading,
          value: '2',
          filterValue: {
            value: '2'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeArriveContainer,
          value: '3',
          filterValue: {
            value: '3'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeExportEntire,
          value: '5',
          filterValue: {
            value: '5'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeExportBillOfLading,
          value: '6',
          filterValue: {
            value: '6'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeExportContainer,
          value: '7',
          filterValue: {
            value: '7'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeTransferInBond,
          value: 'A',
          filterValue: {
            value: 'A'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.actionCodeDiversion,
          value: 'Z',
          filterValue: {
            value: 'Z'
          }
        }
      ]
    },
    {
      label: aceHwyInbondArrivalTranslationText.submittedDate,
      type: 'daterange',
      name: 'submittedDate',
      operatorType: BETWEEN
    },
    {
      label: aceHwyInbondArrivalTranslationText.createdDate,
      type: 'radio',
      name: 'createdDate',
      operatorType: BETWEEN,
      options: [
        {
          label: aceHwyInbondArrivalTranslationText.past15Days,
          value: 'past_15_days',
          filterValue: {
            type: 'date',
            value: {
              startDate: moment().subtract(15, 'days').format(),
              endDate: moment().format()
            }
          }
        },
        {
          label: aceHwyInbondArrivalTranslationText.past30Days,
          value: 'past_30_days',
          filterValue: {
            type: 'date',
            value: {
              startDate: moment().subtract(30, 'days').format(),
              endDate: moment().format()
            }
          }
        },
        {
          label: aceHwyInbondArrivalTranslationText.past60Days,
          value: 'past_60_days',
          filterValue: {
            type: 'date',
            value: {
              startDate: moment().subtract(60, 'days').format(),
              endDate: moment().format()
            }
          }
        }
      ]
    },
    {
      label: aceHwyInbondArrivalTranslationText.lastModifiedDate,
      type: 'radio',
      name: 'updatedDate',
      operatorType: BETWEEN,
      options: [
        {
          label: aceHwyInbondArrivalTranslationText.past15Days,
          value: 'past_15_days',
          filterValue: {
            type: 'date',
            value: {
              startDate: moment().subtract(15, 'days').format(),
              endDate: moment().format()
            }
          }
        },
        {
          label: aceHwyInbondArrivalTranslationText.past30Days,
          value: 'past_30_days',
          filterValue: {
            type: 'date',
            value: {
              startDate: moment().subtract(30, 'days').format(),
              endDate: moment().format()
            }
          }
        },
        {
          label: aceHwyInbondArrivalTranslationText.past60Days,
          value: 'past_60_days',
          filterValue: {
            type: 'date',
            value: {
              startDate: moment().subtract(60, 'days').format(),
              endDate: moment().format()
            }
          }
        }
      ]
    },
    {
      label: aceHighwayInbondEventTranslationText.status,
      type: 'checkbox',
      name: 'status',
      operatorType: IN,
      options: [
        {
          label: aceHighwayInbondEventTranslationText.statusDraft,
          value: 'draft',
          filterValue: {
            value: '1005'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.statusAccepted,
          value: 'accepted',
          filterValue: {
            value: '1000'
          }
        },
        {
          fullWidth: true,
          label: aceHighwayInbondEventTranslationText.statusAcceptedWithWarning,
          value: 'accepted_with_warning',
          filterValue: {
            value: '1015'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.statusSent,
          value: 'sent',
          filterValue: {
            value: '1008'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.statusRejected,
          value: 'rejected',
          filterValue: {
            value: '1001'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.statusNotification,
          value: 'status_notification',
          filterValue: {
            value: '1006'
          }
        },
        {
          label:aceHighwayInbondEventTranslationText.statusPreliminary,
          value: 'preliminary',
          filterValue: {
            value: '1002'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.statusCancellationAccepted,
          value: 'cancellation_accepted',
          filterValue: {
            value: '1003'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.statusCancellationRejected,
          value: 'cancellation_rejected',
          filterValue: {
            value: '1004'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.statusModificationRejected,
          value: 'modification_rejected',
          filterValue: {
            value: '1007'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.statusPL,
          value: 'pl',
          filterValue: {
            value: '1009'
          }
        },
        {
          label: aceHighwayInbondEventTranslationText.statusCP,
          value: 'cp',
          filterValue: {
            value: '1010'
          }
        }
      ]
    }
  ]

  function handleCloneInbondArrival(data) {
    createRecord.execute(
      AceHwyInbondArrivalApiUrls.CLONE,
      data,
      (data) => {
        if(data.filerCode){
          history.push(pathMap.ABI_INBOND_EVENT_ADD_VIEW, InbondEventFormProperties.toClientDataFormat(data))
        }else{
          history.push(pathMap.ACE_HIGHWAY_INBOND_ARRIVAL_ADD_VIEW, InbondArrivalFormProperties.toClientDataFormat(data))
        }
      },
      (error) => {
        console.log(error)
      }
    )
  }

  function handleDeleteInbondArrival() {
    
    if (confirmDialog.inbondArrival) {
      deleteRecord.execute(
        AceHwyInbondArrivalApiUrls.DELETE,
        confirmDialog.inbondArrival,
        () => {
          showNotification('success', aceHwyInbondArrivalTranslationText.deletesuccessMsg)
          setConfirmDialog({ open: false, inbondArrival: null })
          tableRef.current.performRefresh()
        },
        (error) => {
          console.log(error)
        }
      )
    }
  }

  let defaultActions = [
    {
      buttonProps: {
        color: 'primary',
        size: 'medium',
        startIcon: <FontAwesomeIcon icon={['fal', 'upload']} />,
        onClick: () => setUploadInbondEventDialog({ open: true, tableRef: tableRef })
      },
      label: aceHwyInbondArrivalTranslationText.uploadIBStandAlone
    },
    {
      buttonProps: {
        color: 'primary',
        size: 'medium',
        startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
        onClick: () => history.push(pathMap.ACE_HIGHWAY_INBOND_ARRIVAL_ADD_VIEW)
      },
      label: aceHwyInbondArrivalTranslationText.createIBFromManifest
    },
    {
      buttonProps: {
        color: 'primary',
        size: 'medium',
        startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
        onClick: () => history.push(pathMap.ABI_INBOND_EVENT_ADD_VIEW)
      },
      label: aceHwyInbondArrivalTranslationText.createIBStandAlone
    }
  ]

  let upsActions = [
    {
      buttonProps: {
        color: 'primary',
        size: 'medium',
        startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
        onClick: () => history.push(pathMap.ACE_HIGHWAY_INBOND_ARRIVAL_ADD_VIEW)
      },
      label: aceHwyInbondArrivalTranslationText.createIBFromManifest
    }
  ]

  function preSubmit(rows) {
    //const values = { ...manifestData.current, id }
    console.log(isSuperParty)
    if (isSuperParty || (null != user.corpid && undefined != user.corpid && user.corpid.length > 0 && user.corpid[0].serviceBureauFlag)) {
      setSubmitDialog({ open: true, items: rows })
    } else {
      //values.chargeAs = 'REGULAR'
      //manifestData.current = values
      handleSubmit(rows)
    }
  }

  function handleSubmit(rows) {
    
    setLoading(true)
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
       rows.forEach((rowData) => {
        rowData.fileForUserId = fileForUserDetails.fileForUserId;
        rowData.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
        rowData.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
      })
    }

    const config = {}

    securedSendRequest.execute(
      'POST',
      AceHwyInbondArrivalApiUrls.SUBMIT_ALL,
      rows,
      (response) => {
        const data = response.data
        if (data.errorMessages != null && data.errorMessages.length > 0) {
          showNotification('error', data.errorMessages)
        } else {
          showNotification('success', aceHwyInbondArrivalTranslationText.submitSuccessMsg)
        }

        tableRef.current.performRefresh()
        setLoading(false)
      },
      (error) => {
        showNotification('error', aceHwyInbondArrivalTranslationText.submitFailMsg)
        console.log(error)
        setLoading(false)
      },
      {},
      config,
      null
    )
  }

  return (
    <>
      <CngGridItem xs={12} sm={9} shouldHide={loading ? false : true}>
          <CngBackdrop loading={loading} />
      </CngGridItem>
      <Table
        actions={upsUser ? upsActions : defaultActions}
        columns={columns}
        compact
        exportData={{ url: AceHwyInbondArrivalApiUrls.EXPORT }}
        fetch={{ url: AceHwyInbondArrivalApiUrls.GET }}
        fetchFilters={[
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() }
        ]}
        filters={filters}
        onRowClick={(rowData) => {
          if(rowData.status === '1008'){
            null === rowData.tripNo ? history.push(`${location.pathname}-event/view/${rowData.id}`) : history.push(`${location.pathname}/view/${rowData.id}`)
          }else{
            null === rowData.tripNo ? history.push(`${location.pathname}-event/edit/${rowData.id}`) : history.push(`${location.pathname}/edit/${rowData.id}`)
          }
        }}
        rowActions={[
          {
            disabled: (rowData) => rowData.status === '1008',
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: aceHwyInbondArrivalTranslationText.editButton,
            onClick: (rowData) => {
              null === rowData.tripNo ? history.push(`${location.pathname}-event/edit/${rowData.id}`) : history.push(`${location.pathname}/edit/${rowData.id}`)
            },
            tooltip: (rowData) =>
              rowData.status === '1008'
                ? aceHwyInbondArrivalTranslationText.editSentRecords
                : null
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
            label: aceHwyInbondArrivalTranslationText.cloneButton,
            onClick: handleCloneInbondArrival
          },
          {
            disabled: (rowData) => rowData.status !== '1005',
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: aceHwyInbondArrivalTranslationText.deleteButton,
            onClick: (rowData) =>
              setConfirmDialog({ open: true, inbondArrival: rowData })
          },
          {
            disabled: (rowData) => rowData.status !== '1005' && rowData.status !== '1001',
            icon: <FontAwesomeIcon icon={['fal', 'arrow-alt-right']} />,
            label: aceHwyInbondArrivalTranslationText.submitButton,
            onClick: (rowData) => preSubmit([rowData]),
            tooltip: (rowData) => rowData.status !== '1005' && rowData.status !== '1001' ? aceHwyInbondArrivalTranslationText.submitInvalidMsg : null
          },
        ]}
         selectActions={[
          {
            disabled: (rows) => {
              let shouldDisable = false
              rows.forEach((rowData) => {
                if (rowData.status !== '1005' && rowData.status !== '1001') {
                  shouldDisable = true
                }
              })

              return shouldDisable
            },
            icon: <FontAwesomeIcon icon={['fal', 'arrow-alt-right']} />,
            label: aceHwyInbondArrivalTranslationText.submitButton,
            onClick: (rows) => {
              preSubmit(rows)
            },
            tooltip: (rows) => { 
              let shouldDisable = false
              rows.forEach((rowData) => {
                if (rowData.status !== '1005' && rowData.status !== '1001') {
                  shouldDisable = true
                }
              })
              if(shouldDisable){
                return aceHwyInbondArrivalTranslationText.submitInvalidMsg
              }else{
                return null
              }
            }

          }
        ]}
        search={{ field: 'tripNo', operator: LIKE }}
        showNotification={showNotification}
        sortConfig={{
          type: 'column',
          defaultField: 'createdDate',
          defaultDirection: 'DESC'
        }}
        persistSettings
        tableRef={tableRef}
        checkboxSelection
      />
      <InbondEventUploadDialog
        open={uploadInbondEventDialog}
        onClose={() => setUploadInbondEventDialog({ open: false, tableRef: null })}
        showNotification={showNotification}
      />
      <ConfirmDialog
        isConfirmDialogOpen={confirmDialog.open}
        closeDialog={() =>
          setConfirmDialog({ open: false, inbondArrival: null })
        }
        confirmDialog={handleDeleteInbondArrival}
        content= {aceHwyInbondArrivalTranslationText.deleteConfirmationMsg}
        okMsg={aceHwyInbondArrivalTranslationText.deleteConfirmButton}
        cancelMsg={aceHwyInbondArrivalTranslationText.deleteCancelButton}
        title={aceHwyInbondArrivalTranslationText.deleteButton}
      />
      <ChargeTypeDialog
        chargeTypes={chargeTypes}
        onClose={() => setSubmitDialog({ open: false, items: [] })}
        onSubmit={(data) => {
          handleSubmit(submitDialog.items)
        }}
        open={submitDialog.open}
        items={submitDialog.items}
      />
    </>
  )
}

export default TablePage
